import React, { FunctionComponent } from 'react';
import { Menu, MenuDivider, MenuItem } from '../../ui/menu';

interface AppMenuProps {
  onOpen: (item: MenuItem) => void;
  menus: Array<MenuItem | MenuDivider>;
}

export const AppMenu: FunctionComponent<AppMenuProps> = ({ onOpen, menus }) => (
  <Menu menus={menus} onOpen={onOpen} />
);
